/**
 *
 * 最後の呼び出しから少なくとも${ms}ミリ秒経過するまで、提供された関数の呼び出しを遅らせる
 *
 * @param fn コールバック関数
 * @param ms ミリ秒
 */
export const debounce = <T extends unknown[]>(fn: (...args: T) => void, ms: number) => {
  let timeoutId: number;
  return (...args: T) => {
    clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => fn(...args), ms);
  };
};
